module.exports = __webpack_public_path__ + "img/127.a096cb78.jpg";